import React, { useState } from "react";
import { useInterval } from "react-use";
import { useNavigate } from "react-router-dom";

import "./styles.less";
// import { Button } from "../../components/Button";
import { useTranslation } from "react-i18next";

import classnames from "classnames";

export const MainIamSolutions = () => {
  const { t } = useTranslation();
  const [element, setElement] = useState(1);
  const onMouseLeave = () => {};

  const list = [
    {
      title: `${t("page.IAM.item-one.title")}`,
      text: `${t("page.IAM.item-one.subtitle")}`,
      imgurl: "//files.authing.co/authing-website/icon-sso-default.svg",
      path: "/learn/sso",
    },
    {
      title: `${t("page.IAM.item-two.title")}`,
      text: `${t("page.IAM.item-two.subtitle")}`,
      imgurl: "//files.authing.co/authing-website/icon-login.svg",
      path: "/learn/guard",
    },
    {
      title: `${t("page.IAM.item-tree.title")}`,
      text: `${t("page.IAM.item-tree.subtitle")}`,
      imgurl: "//files.authing.co/authing-website/icon-multiple-default.svg",
      path: "/mfa",
    },
    {
      title: `${t("page.IAM.item-four.title")}`,
      text: `${t("page.IAM.item-four.subtitle")}`,
      imgurl: "//files.authing.co/authing-website/icon-usermanage-default.svg",
      path: "/user",
    },
  ];
  const nav = useNavigate();
  const enterDetail = (path) => {
    if (path === "/user") {
      return;
    } else {
      nav(path);
    }
  };
  useInterval(() => {
    if (element < 4) {
      setElement(element + 1);
    } else {
      setElement(1);
    }
  }, 8000);

  return (
    <div className="iam-solution">
      <div className="inner">
        <div key="1" className="top">
          <div className="headline">{t("page.IAM.title")}</div>
          <div className="subline">{t("page.IAM.subtitle")}</div>
        </div>

        <div key="2" className="content">
          <div className="content-left">
            {list.map((item, index) => {
              const cls = classnames({
                item: true,
                selected: element === index + 1,
              });
              const iconCls = classnames({
                icon: true,
                "authing-icon": true,
                "authing-dandiandenglu": index === 0,
                "authing-zujian": index === 1,
                "authing-duoyinsu": index === 2,
                "authing-sidebar-user": index === 3,

                selected: element === index + 1,
              });
              return (
                <div
                  className={cls}
                  onMouseEnter={() => setElement(index + 1)}
                  onMouseLeave={onMouseLeave}
                  onClick={() => {
                    enterDetail(item.path);
                  }}
                >
                  <div className="item-icon">
                    <i className={iconCls}></i>
                  </div>
                  <div className="item-content">
                    <div className="item-title">{item.title}</div>
                    <div className="item-text">{item.text}</div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="content-right">
            <div className="img">
              {element === 1 && <img src={"//files.authing.co/authing-website/iam-sso-img.svg"} alt="authing iam" />}
              {element === 2 && (
                <img src={"//files.authing.co/authing-website/iam-logincomp-img.svg"} alt="authing iam" />
              )}
              {element === 3 && <img src={"//files.authing.co/authing-website/iam-multiple.svg"} alt="authing iam" />}
              {element === 4 && <img src={"//files.authing.co/authing-website/iam-user.svg"} alt="authing iam" />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
